<template>
  <img
    :src="$helper.getLinkToIlBucketFile('investing-live-logo.svg')"
    alt="investingLive"
    class="footer-logo"
  />
</template>

<script>
export default {
  name: 'FooterLogo'
}
</script>
